import { Link } from "react-router-dom";

export function NotFoundPage() {
	return (
		<div
			style={{
				minHeight: "100vh",
				display: "grid",
				placeItems: "center",
				background: "var(--a-bg)",
				padding: 24,
				textAlign: "center",
			}}
		>
			<div>
				<div
					style={{
						fontFamily: "var(--a-font-display)",
						fontWeight: 900,
						fontSize: 96,
						color: "var(--a-terracotta)",
						letterSpacing: "-0.04em",
						lineHeight: 1,
					}}
				>
					404
				</div>
				<h1
					style={{
						fontFamily: "var(--a-font-display)",
						fontWeight: 700,
						fontSize: 22,
						margin: "12px 0 6px",
					}}
				>
					Page introuvable
				</h1>
				<p className="muted" style={{ marginBottom: 18 }}>
					La page demandée n'existe pas ou a été déplacée.
				</p>
				<Link to="/" className="btn btn-primary">
					Retour au tableau de bord
				</Link>
			</div>
		</div>
	);
}
